import React, { useState } from 'react';
import './CourseCardNew.scss';
import YCIcon from '../../../assets/images/Courses/thumbnail.png';
import { Button } from 'react-bootstrap';
import { AccessTime, CurrencyRupee } from '@mui/icons-material';
import { getAvatarForUser } from '../../../Utilities';
import InitialsAvatar from '../../Login/Preloader/InitialsAvatar';
import { Divider } from '@material-ui/core';

const AppointmentCardNew = ({ item, onClick }) => {
  const [colors, setColors] = useState([
    '#d4a373',
    '#f08080',
    '#a0c4ff',
    '#abc4ff',
    '#84dcc6',
    '#b388eb',
    '#a7bed3',
    '#e7cee3',
    '#e4b4c2',
    '#fcd29f',
    '#d2e0bf',
  ]);

  // Format the timestamp to a readable date
  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  // Calculate discount percentage
  //   const discountPercentage =
  //     item.price && item.price ? Math.round(((item.price - item.price) / item.price) * 100) : 0;

  return (
    <div role='button' onClick={onClick} className='appointment-card-new'>
      <div
        style={{ backgroundColor: colors[Math.floor(Math.random() * colors.length)] }}
        className='appointment-card-new__image-wrapper'
      >
        <img src={item.image || YCIcon} alt={item.title} className='appointment-card-new__image' />
      </div>

      <div className='appointment-card-new__content pb-0'>
        <h3 className='appointment-card-new__title text-left clampOn2Line'>{item.title}</h3>

        <div style={{ background: '#f4f5f7', padding: '12px', borderRadius: '8px' }}>
          <div className='appointment-card-new__meta'>
            <span style={{ fontSize: '14px' }} className='appointment-card-new__date '>
              <div>
                <p className='mb-0'>{item.duration} mins</p>
                <p
                  style={{ fontFamily: 'Montserrat-Regular', color: 'gray', fontSize: '12px' }}
                  className='mb-0'
                >
                  Duration
                </p>
              </div>
            </span>
            <Divider
              style={{ transform: 'rotate(90)', borderRight: '#ccc', height: '40px', width: '1px' }}
            />
            <span style={{ fontSize: '16px' }} className='appointment-card-new__price '>
              <p className='mb-0 '>₹ {item.price}</p>
              <p
                style={{ fontFamily: 'Montserrat-Regular', color: 'gray', fontSize: '12px' }}
                className='mb-0 font'
              >
                Booking Fee
              </p>
            </span>
          </div>

          <div className='appointment-card-new__footer'>
            <div className='appointment-card-new__pricing d-flex align-items-center justify-content-between'>
              {/* <span className='appointment-card-new__price'>₹{item.price}</span> */}
              <Button
                className='w-100'
                style={{ borderRadius: '10px' }}
                variant='customPrimarySquare'
                // onClick={() => history.push(item.sharePathname)}
              >
                Book Now
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentCardNew;
